/** Thresholds for non-blocking smart-defaults warnings. */

export const COGS_WARNING_THRESHOLD_PERCENT = 60;

export const REPLENISHMENT_WARNING_THRESHOLD_DAYS = 60;

/** Standard GST slabs (India) — 0%, 0.25%, 3%, 5%, 18%, 40%. */
export const GST_SLABS = [0, 0.25, 3, 5, 18, 40];

export const GST_SLABS_LABEL = '0%, 0.25%, 3%, 5%, 18%, or 40%';

const isFiniteNumber = (value) => {
    const n = Number(value);
    return Number.isFinite(n);
};

export const isGstSlab = (value) => {
    if (value == null || value === '') return true;
    if (!isFiniteNumber(value)) return true;
    const n = Number(value);
    return GST_SLABS.some((slab) => Math.abs(n - slab) < 0.001);
};

export const getCogsWarning = (value) => {
    if (!isFiniteNumber(value)) return null;
    if (Number(value) > COGS_WARNING_THRESHOLD_PERCENT) {
        return `COGS above ${COGS_WARNING_THRESHOLD_PERCENT}% of selling price is unusually high. Most sellers land between 20–50%. Confirm this matches your real unit cost.`;
    }
    return null;
};

export const getReplenishmentWarning = (value) => {
    if (!isFiniteNumber(value)) return null;
    if (Number(value) > REPLENISHMENT_WARNING_THRESHOLD_DAYS) {
        return `Replenishment above ${REPLENISHMENT_WARNING_THRESHOLD_DAYS} days is a long lead time. Make sure this reflects how long it actually takes to restock your catalog.`;
    }
    return null;
};

export const getTaxPaidOnCogsWarning = (value) => {
    if (value == null || value === '') return null;
    if (isGstSlab(value)) return null;
    return `Tax paid on COGS isn’t a standard GST slab (${GST_SLABS_LABEL}). Verify the rate - special categories like gold (3%) or precious stones (0.25%) may apply.`;
};

export const getTaxCollectedWarning = (value) => {
    if (value == null || value === '') return null;
    if (isGstSlab(value)) return null;
    return `Tax collected on sales isn’t a standard GST slab (${GST_SLABS_LABEL}). 18% is the default for most goods - double-check if another slab fits your category.`;
};
